import { onDocumentReady } from '@theme/utilities';

const DEFERRED_VIDEO_SELECTOR = '[data-deferred-slideshow-video]';
const DEFAULT_VIDEO_DELAY = 150;

/**
 * Hydrates a deferred slideshow video after the poster has had a chance to paint.
 * @param {HTMLVideoElement} video
 */
function loadDeferredVideo(video) {
    if (video.dataset.videoLoaded === 'true') return;

    const sources = video.querySelectorAll('source[data-video-source]');

    for (const source of sources) {
        const { videoSource } = source.dataset;

        if (videoSource) source.setAttribute('src', videoSource);
    }

    video.addEventListener(
        'playing',
        () => {
            video.dataset.videoLoaded = 'true';
        },
        { once: true }
    );

    video.load();
    video.play().catch(() => {});
}

function initDeferredSlideshowVideos() {
    const videos = document.querySelectorAll(DEFERRED_VIDEO_SELECTOR);

    if (!videos.length) return;

    for (const video of videos) {
        if (!(video instanceof HTMLVideoElement)) continue;

        const delay = Number.parseInt(video.dataset.deferredVideoDelay || '', 10) || DEFAULT_VIDEO_DELAY;

        window.setTimeout(() => {
            window.requestAnimationFrame(() => loadDeferredVideo(video));
        }, delay);
    }
}

onDocumentReady(initDeferredSlideshowVideos);
